/*globals debounce */

window.sanitasApp = window.sanitasApp || {}
window.sanitasApp.utils = window.sanitasApp.utils || {}
;(function (sanitasApp, window, document) {
  'use strict'

  sanitasApp.utils = {
    /**
     * Looks for elements of a provided selector and set the height of the highest element
     * within a san-row for each element with the same selector.
     *
     * @param {String} querySelector css-selector of component
     */
    autoHeight: function (querySelector) {
      var _querySelector = querySelector
      var queryElements = document.querySelectorAll(querySelector)
      var parents = []

      findCommonParents()
      prepareElements()

      /**
       * findCommonParents - description
       */
      function findCommonParents() {
        ;[].forEach.call(queryElements, function (element) {
          var _parent = element.closest('.san-row')
          if (!_parent.classList.contains('js-has-been-added')) {
            _parent.classList.add('js-has-been-added')
            parents.push(_parent)
          }
        })
      }

      /**
       * processElements - description
       */
      function processElements() {
        ;[].forEach.call(parents, function (parent) {
          getHeightOfCommonElements(parent, setHeightOfCommonElements)
        })
      }

      /**
       * getHeightOfCommonElements - description
       *
       * @param  {Object} parent
       * @param  {Function} callback
       */
      function getHeightOfCommonElements(parent, callback) {
        var _height = 0
        var commonElements = parent.querySelectorAll(_querySelector)

        ;[].forEach.call(commonElements, function (element) {
          element.style.height = 'auto'
          var currentElementHeight = parseInt(
            window.getComputedStyle(element).height,
          )
          if (_height < currentElementHeight) {
            _height = currentElementHeight
          }
        })

        callback(commonElements, _height)
      }

      /**
       * missing JSDoc
       *
       * @param {array} commonElements
       * @param {number} commonHeight
       */
      function setHeightOfCommonElements(commonElements, commonHeight) {
        ;[].forEach.call(commonElements, function (element) {
          element.style.height = commonHeight + 'px'
        })
      }

      /**
       * missing JSDoc
       *
       * @param {function} callback
       */
      function reSetHeightOfCommonElements(callback) {
        var _autoHeight = 'auto'
        ;[].forEach.call(queryElements, function (panel) {
          panel.style.height = _autoHeight
        })
        callback()
      }

      /**
       * prepareElements - description
       */
      function prepareElements() {
        window.addEventListener(
          'resize',
          debounce(function () {
            reSetHeightOfCommonElements(processElements)
          }, 150),
        )

        /**
         * Needed in order to correctly calculate the height when all resources are loaded
         */
        window.addEventListener('load', function () {
          processElements()
        })
      }
    },
  }
})(window.sanitasApp, window, document)
